export type AppConfig = {
  apiPrefix: string;
  authenticatedEntryPath: string;
  unAuthenticatedEntryPath: string;
  tourPath: string;
  locale: string;
  enableMock: boolean;
  showLog?: boolean;
};

export const appConfig: AppConfig = {
  apiPrefix: '/api',
  authenticatedEntryPath: '/home',
  unAuthenticatedEntryPath: '/sign-in',
  tourPath: '/',
  locale: 'en',
  enableMock: true,
  showLog: true,
};

export const sliceTagTypes = [
  'Brands',
  'Category',
  'Unit',
  'Genetic',
  'Strength',
  'Type',
  'Products',
  'Roles',
  'Roles_Permissions',
  'Users',
  'Cart_Sale',
  'Inventory_Stock',
  'Inventory_Sale',
  'Purchases',
  'Cart_Clear',
  'Customers',
  'Auth_User',
  'Orders',
  'Expense',
  'Expense-Category',
  'Transaction',
];
